import { registerComponent } from './components-front'

registerComponent('modal', _ => {
    const selectors = [
        '[data-type=ComponentModal]',
        '[data-type=ComponentImageTextOverlay] [data-type=booking]',
        '[data-type=ComponentBookingForm]',
        '[data-type=ComponentContactForm]',
        '[data-type=ComponentDownloadForm]',
        '[data-type=ComponentEnewsSignupForm]',
    ]

    selectors.forEach(selector => {
        document.querySelectorAll(selector).forEach(comp => {
            // Generic modal open/close (used by ComponentModal etc.)
            const modal = comp.querySelector('.modal-component')
            if (modal) {
                const modalWrap = modal.firstElementChild
                const btn = comp.querySelector('.modal-btn')
                const close = modal.querySelector('.modal-close')

                // Auto-open if flagged (replaces the old auto-load div approach)
                if (modal.dataset.autoOpen) {
                    modal.classList.remove('d-none')
                    modal.classList.add('d-flex')
                }

                if (btn) {
                    btn.addEventListener('click', _ => {
                        modal.classList.remove('d-none')
                        modal.classList.add('d-flex')
                    })
                }

                if (close) {
                    close.addEventListener('click', _ => {
                        modal.classList.add('d-none')
                        modal.classList.remove('d-flex')
                    })
                }

                modal.addEventListener('click', ev => {
                    if (!modalWrap.contains(ev.target)) {
                        modal.classList.add('d-none')
                        modal.classList.remove('d-flex')
                    }
                })
            }

            // Form component modal buttons (data-target="#form-modal-{id}")
            comp.querySelectorAll('.form-component-modal-btn').forEach(btn => {
                const targetId = btn.dataset.target
                if (!targetId) return
                const target = document.querySelector(targetId)
                if (!target) return
                const targetWrap = target.firstElementChild
                const close = target.querySelector('.modal-close')

                btn.addEventListener('click', _ => {
                    target.classList.remove('d-none')
                    target.classList.add('d-flex')
                })

                if (close) {
                    close.addEventListener('click', _ => {
                        target.classList.add('d-none')
                        target.classList.remove('d-flex')
                    })
                }

                target.addEventListener('click', ev => {
                    if (!targetWrap.contains(ev.target)) {
                        target.classList.add('d-none')
                        target.classList.remove('d-flex')
                    }
                })
            })

            // Auto-open for form-component modals (data-auto-open on the modal div)
            comp.querySelectorAll('.modal-component[data-auto-open]').forEach(target => {
                target.classList.remove('d-none')
                target.classList.add('d-flex')
            })
        })
    })
})
